import type { APIRequestPathParams, APIResponse } from './base-fetch';
import { get } from './base-fetch';

export type ValidateInviteAccountParams =
  APIRequestPathParams<'/api/v4/accounts/validate-invite-to-account/{accountId}'>;

export type ValidateInviteAccountResponse =
  APIResponse<'/api/v4/accounts/validate-invite-to-account/{accountId}'>;

export const validateInviteToAccount = ({
  accountId,
}: ValidateInviteAccountParams): Promise<ValidateInviteAccountResponse> =>
  get<ValidateInviteAccountResponse>(
    `/v4/accounts/validate-invite-to-account/${accountId}`,
  );
